module.exports = __webpack_public_path__ + "img/songlei.1a01efb3.jpg";